/* eslint-disable import/no-mutable-exports */
import get from 'lodash.get';

// eslint-disable-next-line no-var
export var getLoadingBool = ({ search }) => (get(search, 'results.loading', false));

export const getSearchForm = ({ search }) => get(search, 'form', {});

export const getCandidates = ({ search }) => (get(search, 'results.candidates', []));
export const totalCandidatesCount = ({ search }) => (get(search, 'results.totalCount', 0));
export const getResultsMeta = ({ search }) => {
  // eslint-disable-next-line no-unused-vars
  const { candidates, ...rest } = get(search, 'results', {});
  return rest;
};
